// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__kdPme","head":"styles_head__8cPBe","buttonGroup":"styles_buttonGroup__K1nzG","button":"styles_button__RFGO6","buttonTabs":"styles_buttonTabs__W3ZGm"};